import { Controller } from '@hotwired/stimulus'

// Popup rules in the builder: each segmented control writes one hidden input, and a section marked
// data-when="key:value,value" shows only while that rule has one of those values.
export default class extends Controller {
  static targets = ['choice', 'reveal', 'output']

  connect() {
    this.sync()
  }

  choose(event) {
    const { ruleKey, value } = event.currentTarget.dataset
    const input = this.input(ruleKey)
    if (input) input.value = value
    this.sync()
  }

  // Empties a date (or any field) named by data-clear, and tells the preview it changed.
  clear(event) {
    const input = this.element.querySelector(event.currentTarget.dataset.clear)
    if (!input) return
    // A flatpickr date field shows its date in a second input, so clear through the picker.
    const picker = input._flatpickr
    if (picker) picker.clear(false)
    else input.value = ''
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.dispatchEvent(new Event('change', { bubbles: true }))
    if (!picker) input.focus()
  }

  sync() {
    this.choiceTargets.forEach((button) => {
      const active = this.input(button.dataset.ruleKey)?.value === button.dataset.value
      button.classList.toggle('active', active)
      button.setAttribute('aria-pressed', active)
    })
    this.revealTargets.forEach((section) => {
      const [key, values] = section.dataset.when.split(':')
      section.hidden = !values.split(',').includes(this.input(key)?.value)
    })
    this.outputTargets.forEach((output) => {
      const range = this.element.querySelector(`#${output.dataset.for}`)
      if (range) output.textContent = `${range.value}${output.dataset.unit}`
    })
  }

  input(key) {
    return this.element.querySelector(`input[type="hidden"][data-rule-key="${key}"]`)
  }
}
